import React from 'react';
import {
  InternationalPhoneInput,
  InternationalPhoneInputProps,
  IntlPhoneInputValue,
} from './InternationalPhoneInput';

interface PhoneCountryCodeAndNumber {
  countryCode?: string;
  number: string;
  dialCode?: string;
}

interface InternationalPhoneInputWithinFormProps extends InternationalPhoneInputProps {
  onBlurHandler: (event: React.FocusEvent<HTMLInputElement>, value: IntlPhoneInputValue) => void;
  onChange: (value: IntlPhoneInputValue) => void;
  updateFormState?: (value: PhoneCountryCodeAndNumber) => void;
  value: PhoneCountryCodeAndNumber;
}

export const InternationalPhoneInputWithinForm: React.FC<InternationalPhoneInputWithinFormProps> = ({
  onBlurHandler,
  onChange,
  updateFormState,
  ...rest
}) => {
  const changeHandler = (val: IntlPhoneInputValue) => {
    const updatedValue = {
      number: val.number,
      countryCode: val.countryCode,
      dialCode: val.dialCode,
    };

    onChange(updatedValue);
    if (updateFormState) {
      updateFormState(updatedValue);
    }
  };

  return (
    <InternationalPhoneInput
      {...rest}
      onChange={changeHandler}
      onBlurHandler={onBlurHandler}
    />
  );
};

export default InternationalPhoneInputWithinForm;